//chatbot code

export function chatBot() {
  const tab = document.getElementById("chat-tab");
  const chatContainer = document.getElementById("chat-container");
  const chatWindow = document.getElementById("chat-window");
  const closeBtn = document.getElementById("chat-close");
  const iframe = document.getElementById("askbu-chat");

  //open chat function
  const openChat = (event) => {
    //chatWindow.style.display = 'block';
    chatContainer.style.display = "block";
    closeBtn.style.display = "block";
    tab.style.display = "none";
    // Only set the src once – this starts the chat session
    if (!iframe.src) {
      iframe.src =
        "https://copilotstudio.microsoft.com/environments/Default-ede29655-d097-42e4-bbb5-f38d427fbfb8/bots/cr4f3_agent1/webchat";
    }
  };

  //close chat function
  const closeChat = (event) => {
    //chatWindow.style.display = 'none';
    chatContainer.style.display = "none";
    closeBtn.style.display = "none";
    tab.style.display = "block";
  };

  tab.addEventListener("click", openChat);
  tab.addEventListener("keypress", openChat);

  closeBtn.addEventListener("click", closeChat);
  closeBtn.addEventListener("keypress", closeChat);
}

export function getFullYear() {
  const yearElement = document.querySelector(".js-copyright-year");
  yearElement.textContent = new Date().getFullYear();
}
